export enum ContestTypeEnum {
    Common = 'Normal',
    Special = 'Affiliate links',
}